// Resource fields used by the resource filters and the create/edit form.

// Audience is the existing "Who Should Attend" text, saved as "Companies|Executives",
// so the label is also the saved value.
export const AUDIENCE_SEPARATOR = "|"

export const audienceOptions = [
  { id: "Companies", value: "Companies" },
  { id: "Organizations", value: "Organizations" },
  { id: "Freelancers", value: "Freelancers" },
  { id: "Solopreneurs", value: "Solopreneurs" },
  { id: "Executives", value: "Executives" },
  { id: "Professionals", value: "Professionals" },
]

// New optional lists. `id` values mirror the API (Resource::LIST_FIELDS), `value` is the label.
export const contentPurposeOptions = [
  { id: "learn", value: "Learn" },
  { id: "implement", value: "Implement" },
  { id: "find_funding", value: "Find Funding" },
  { id: "grow_network", value: "Grow Network" },
  { id: "solve_a_problem", value: "Solve a Problem" },
  { id: "stay_informed", value: "Stay Informed" },
  { id: "be_inspired", value: "Be Inspired" },
  { id: "advance_career", value: "Advance Career" },
  { id: "improve_business_operations", value: "Improve Business Operations" },
  { id: "other", value: "Other" },
]

export const resourceFeatureOptions = [
  { id: "advisory", value: "Advisory" },
  { id: "bootcamp", value: "Bootcamp" },
  { id: "career_services", value: "Career Services" },
  { id: "certification", value: "Certification" },
  { id: "education", value: "Education" },
  { id: "financial_tools", value: "Financial Tools" },
  { id: "grant", value: "Grant" },
  { id: "incubator", value: "Incubator" },
  { id: "investment", value: "Investment" },
  { id: "loan", value: "Loan" },
  { id: "membership", value: "Membership" },
  { id: "online_course", value: "Online Course" },
  { id: "report", value: "Report" },
  { id: "research", value: "Research" },
]

/** "Companies|Executives" -> ["Companies", "Executives"]; unknown saved values are kept. */
export const parseAudience = (value) =>
  String(value || "")
    .split(AUDIENCE_SEPARATOR)
    .map((item) => item.trim())
    .filter(Boolean)

export const serializeAudience = (values) => values.join(AUDIENCE_SEPARATOR)

/** Audience options plus any other value already saved on the resource, so editing never drops it. */
export const audienceChoices = (value) => {
  const known = new Set(audienceOptions.map(({ id }) => id))
  const extra = parseAudience(value)
    .filter((item) => !known.has(item))
    .map((item) => ({ id: item, value: item }))
  return [...audienceOptions, ...extra]
}

const LIST_FIELDS = ["content_purposes", "resource_features"]

export const criteriaInitialValues = (data = {}) =>
  Object.fromEntries(LIST_FIELDS.map((name) => [name, data[name] || []]))

/** Multipart forms can't send arrays, so lists are sent comma separated. */
export const serializeCriteria = (values) => ({
  ...values,
  ...Object.fromEntries(
    LIST_FIELDS.map((name) => [name, (values[name] || []).join(",")]),
  ),
})
